var React = require('react');

function NotfallIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 6.09859H5.63757V0.460938H11.2943V6.09859H16.932V11.7362H11.2943V17.3738H5.65668V11.7362H0.019104V6.09859H0Z","fill":"var(--color-gray-almostwhiter)"}));
}

NotfallIcon.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = NotfallIcon;

NotfallIcon.default = NotfallIcon;
